import LocaleController from '@/assets/controllers/LocaleController'

function getString (key) {
    return LocaleController.getString(key)
}
const EXTENDED_NUMERIC = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: 'Enter', classes: 'control featured'},
        'next': {func: 'next', text: `${getString('Prox')}`, classes: 'control featured'},
        'zero': {key: '0', width: 130}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '/ , . {zero} {backspace} {next} {accept}'
    ]
}

const EXTENDED_NUMERIC_NO_NEXT = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('fechar')}`, classes: 'control featured'},
        'zero': {key: '0', width: 130}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '/ , . {zero} {backspace} {accept}'
    ]
}

const EMAIL = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: 'Enter', classes: 'control featured'}
    },
    default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        'z x c v b n m . - _',
        '@ .com .br {backspace} {clear}'
    ]
}

const MONEY_NUMERIC = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('fechar')}`, classes: 'control featured'}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '0 , {backspace} {accept}'
    ]
}

const MONEY_NUMERIC_NO_CONFIRM = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('fechar')}`, classes: 'control featured'}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '0 , {backspace}'
    ]
}

const SIMPLE_NUMERIC = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('fechar')}`, classes: 'control featured'}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '{backspace} 0 {accept}'
    ]
}

const PHONE_NUMBER = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('confirmar')}`, classes: 'control featured'}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '0 + - {backspace}'
    ]
}
const CPF_NUMBER = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('confirmar')}`, classes: 'control featured'},
        'limpar': {func: 'next', key: 'Limpar', classes: 'control-limpar'}
    }
}
const SIMPLE_PHONE_NUMBER = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('confirmar')}`, classes: 'control featured'}
    },
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '{clear} 0 {backspace}'
    ]
}

const LOGIN_AND_PASSWORD = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: 'Enter', classes: 'control featured'},
        'paste': {func: 'paste', text: 'Colar'}
    },
    default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        '{shift} z x c v b n m {paste}',
        '{clear} @ $ # . - _ : / {backspace}'
    ]
}

const TEXT = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: 'Enter', classes: 'control featured'}
    },
    default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        'z x c v b n m . , ?',
        '{clear} {space} {backspace}'
    ]
}
const NAME = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: 'Enter', classes: 'control featured'}
    },
    default: [
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        'Z X C V B N M',
        '{clear} {space} {backspace}'
    ]
}

const ALPHANUMERIC_CNPJ = {
    _meta: {
        'backspace': {func: 'backspace', classes: 'control'},
        'accept': {func: 'accept', text: `${getString('confirmar')}`, classes: 'control featured'}
    },
    default: [
        '1 2 3 4 5 6 7 8 9 0',
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        '{clear} Z X C V B N M {backspace}'
    ]
}

export default {
    EXTENDED_NUMERIC,
    EXTENDED_NUMERIC_NO_NEXT,
    EMAIL,
    MONEY_NUMERIC,
    SIMPLE_NUMERIC,
    PHONE_NUMBER,
    CPF_NUMBER,
    SIMPLE_PHONE_NUMBER,
    MONEY_NUMERIC_NO_CONFIRM,
    LOGIN_AND_PASSWORD,
    TEXT,
    NAME,
    ALPHANUMERIC_CNPJ
}



// WEBPACK FOOTER //
// ./src/assets/libs/keyboardLayout.js